import React, { useEffect } from "react";
import Main from "../../components/HOC/Main";
import { useDispatch, useSelector } from "react-redux";
import { fetchStat, selectStatData } from "../../store/slices/api/inner/statSlice";
import congratulation from '../../assets/images/congratulation.svg'

const DashboardPage = () => {
    const dispatch = useDispatch();
    const adminData = useSelector((state) => {
        return state?.loginUser?.data;
    })
    const data = useSelector(selectStatData);

    useEffect(() => {
        dispatch(fetchStat());
    }, [dispatch]);

    return (
        <Main>
            <h1 className="inline-flex items-center mb-4">
                <p className="inline-flex font-semibold items-center text-2xl text-gray-700">
                    Welcome to Admin Dashboard 🎊
                </p>
            </h1>
            <div className="p-6 bg-gray-100 min-h-auto" >
                <div className="flex justify-between gap-4 mb-6 banner-section">
                    <div className="bg-white p-6 rounded-lg shadow-md flex items-center justify-between banner-left">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-800">
                                Welcome {adminData?.authUserData?.admin_name}!
                            </h2>
                            <p className="text-gray-600">
                                Admin Control Panel gives you access to manage all your website Masters, configurations, users, transactions, Jobs etc. at one place.
                            </p>
                        </div>
                        <div className="w-48 h-48"> {/* Adjust width and height here */}
                            {/* Illustration image */}
                            <img
                                src={congratulation}
                                alt="Illustration"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* Cards Section */}
                    <div className="flex flex-wrap gap-6 banner-right">
                        <div className="flex w-full gap-4">
                            {/* Card 1 - Users */}
                            <div className="bg-white p-6 rounded-lg shadow-md w-full text-center">
                                <h3 className="text-gray-600">Users</h3>
                                <p className="text-2xl font-bold text-gray-800">{data?.data?.Users || 0}</p>
                            </div>

                            {/* Card 2 - Blogs */}
                            <div className="bg-white p-6 rounded-lg shadow-md w-full text-center">
                                <h3 className="text-gray-600">Blogs</h3>
                                <p className="text-2xl font-bold text-gray-800">{data?.data?.Blogs || 0}</p>
                            </div>
                        </div>

                        <div className="flex w-full gap-4">
                            {/* Card 3 - Enquiries */}
                            <div className="bg-white p-6 rounded-lg shadow-md w-full text-center">
                                <h3 className="text-gray-600">Enquiries</h3>
                                <p className="text-2xl font-bold text-gray-800">{data?.data?.Enquiries || 0}</p>
                            </div>

                            {/* Card 4 - Partners */}
                            <div className="bg-white p-6 rounded-lg shadow-md w-full text-center">
                                <h3 className="text-gray-600">Partners</h3>
                                <p className="text-2xl font-bold text-gray-800">{data?.data?.Partners || 0}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex gap-6 bottom-card-container">
                    {/* Card 1 - Team Member */}
                    <div className="card bg-white p-6 rounded-lg shadow-md w-full sm:w-1/2 md:w-1/2 lg:w-1/4 text-center">
                        <h3 className="text-gray-600">Banners</h3>
                        <p className="text-2xl font-bold text-gray-800">{data?.data?.Banners || 0}</p>
                    </div>

                    {/* Card 2 - Status */}
                    <div className="card bg-white p-6 rounded-lg shadow-md w-full sm:w-1/2 md:w-1/2 lg:w-1/4 text-center">
                        <h3 className="text-gray-600">Team Members</h3>
                        <p className="text-2xl font-bold text-gray-800">{data?.data?.TeamMebers || 0}</p>
                    </div>

                    {/* Card 3 - Jobs */}
                    <div className="card bg-white p-6 rounded-lg shadow-md w-full sm:w-1/2 md:w-1/2 lg:w-1/4 text-center">
                        <h3 className="text-gray-600">Jobs</h3>
                        <p className="text-2xl font-bold text-gray-800">{data?.data?.Jobs || 0}</p>
                    </div>

                    {/* Card 4 - Transactions */}
                    <div className="card bg-white p-6 rounded-lg shadow-md w-full sm:w-1/2 md:w-1/2 lg:w-1/4 text-center">
                        <h3 className="text-gray-600">Transactions Count</h3>
                        <p className="text-2xl font-bold text-gray-800">{data?.data?.Transactions || 0}</p>
                    </div>
                </div>
            </div>
        </Main>
    );
};

export default DashboardPage;